module.exports = __webpack_public_path__ + "img/login-bkg-logo.54244667.png";